// SN gateway logs have no signal. Anything else, even NaN, goes on to getSignalLabel so it can be reported
export const getSnNodeLogSignalRSSI = (signal: number | null | undefined) =>
  signal === undefined || signal === null ? undefined : signal * -1
